import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useT } from '../i18n/translations';
import Drawer from './Drawer';
import Icon from './Icon';
import './AuthDrawer.css';

export default function AuthDrawer() {
  const { lang, login, toast } = useApp();
  const t = useT(lang);
  const [mode, setMode] = useState('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes('@') || password.length < 6) {
      toast('請輸入有效 Email 與至少 6 碼密碼', 'error');
      return;
    }
    if (mode === 'signup') {
      if (password !== confirm) {
        toast('密碼不一致', 'error');
        return;
      }
      if (!agree) {
        toast('請勾選同意服務條款', 'error');
        return;
      }
    }
    setLoading(true);
    try {
      await login(email, password);
    } catch (_) {
      // toast already shown in context
    } finally {
      setLoading(false);
    }
  };

  const isSignin = mode === 'signin';

  return (
    <Drawer
      id="auth"
      title={isSignin ? t.auth.signinTitle : t.auth.signupTitle}
      icon="user"
      width={420}
    >
      <div className="nx-auth__welcome">
        <div className="nx-auth__crest">
          <span className="nx-logo__mark">
            <span className="nx-logo__hex" />
            <span className="nx-logo__hex2" />
          </span>
        </div>
        <h3>{isSignin ? t.auth.welcome : t.auth.welcomeNew}</h3>
        <p className="muted">登入即享 QQCARD 點數回饋 · VIP 等級 · 訂單追蹤</p>
      </div>

      <form className="nx-auth__form" onSubmit={submit}>
        <label className="nx-auth__field">
          <span>{t.auth.email}</span>
          <div className="nx-auth__input">
            <Icon name="mail" size={14} />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
            />
          </div>
        </label>
        <label className="nx-auth__field">
          <span>{t.auth.password}</span>
          <div className="nx-auth__input">
            <Icon name="lock" size={14} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 6 碼"
              required
              autoComplete={isSignin ? 'current-password' : 'new-password'}
              minLength={6}
            />
          </div>
        </label>
        {!isSignin && (
          <label className="nx-auth__field">
            <span>{t.auth.confirmPassword}</span>
            <div className="nx-auth__input">
              <Icon name="check" size={14} />
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>
          </label>
        )}

        {isSignin && (
          <div className="nx-auth__row">
            <label className="nx-auth__check">
              <input type="checkbox" defaultChecked />
              <span>記住我</span>
            </label>
            <button type="button" className="nx-auth__link">{t.auth.forgotPw}</button>
          </div>
        )}
        {!isSignin && (
          <label className="nx-auth__check nx-auth__check--full">
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <span>{t.auth.agree}</span>
          </label>
        )}

        <button
          type="submit"
          className="btn btn-primary btn-block btn-lg"
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="nx-spinner" /> 處理中...
            </>
          ) : isSignin ? (
            t.auth.signinBtn
          ) : (
            t.auth.signupBtn
          )}
        </button>
      </form>

      <div className="nx-auth__divider">
        <span>{t.auth.orContinue}</span>
      </div>

      <div className="nx-auth__socials">
        <button className="nx-auth__social" onClick={() => login('user@google.com')}>
          <Icon name="google" size={18} /> Google
        </button>
        <button className="nx-auth__social" onClick={() => login('user@apple.com')}>
          <Icon name="apple" size={18} /> Apple
        </button>
        <button
          className="nx-auth__social"
          onClick={() => login('user@line.me')}
        >
          <Icon name="line" size={18} /> LINE
        </button>
        <button className="nx-auth__social" onClick={() => login('user@fb.com')}>
          <Icon name="facebook" size={18} /> Facebook
        </button>
      </div>

      <p className="nx-auth__switch">
        {isSignin ? t.auth.noAccount : t.auth.hasAccount}
        <button onClick={() => setMode(isSignin ? 'signup' : 'signin')}>
          {isSignin ? t.auth.signupBtn : t.auth.signinBtn}
        </button>
      </p>
    </Drawer>
  );
}
